import { Component } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environment/environment';

@Component({
  standalone: true,
  selector: 'app-server-down',
  imports: [CommonModule],
  template: `
    <div class="server-wrap">
      <div class="server-card">

        <div class="alert-icon">🚨</div>

        <h1>Service Temporarily Unavailable</h1>
        <p class="subtitle">
          Our servers are currently unreachable. This may be due to maintenance
          or a temporary network issue.
        </p>

        <div class="button-row">
          <button class="retry-btn" (click)="retryNow()">
            Retry Connection
          </button>

          <button class="back-btn" (click)="goBack()">
            Go Back
          </button>
        </div>

      </div>
    </div>
  `,
  styles: [`
    /* ✅ Clean Light Enterprise Background */
    .server-wrap {
      height: 100vh;
      background: linear-gradient(135deg, var(--fd-soft-bg), #e2e8f0);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0f172a;
      font-family: "Inter", system-ui;
    }

    .server-card {
      width: 100%;
      max-width: 520px;
      padding: 50px;
      border-radius: 22px;
      background: var(--fd-surface);
      box-shadow: 0 25px 60px rgba(0, 0, 0, 0.12);
      text-align: center;
      animation: fadeUp 0.35s ease-out;
    }

    .alert-icon {
      font-size: 46px;
      margin-bottom: 14px;
    }

    h1 {
      font-size: 26px;
      margin-bottom: 10px;
      font-weight: 700;
      letter-spacing: 0.3px;
    }

    .subtitle {
      font-size: 14px;
      opacity: 0.8;
      line-height: 1.6;
    }

    .button-row {
      margin-top: 36px;
      display: flex;
      gap: 16px;
      justify-content: center;
      flex-wrap: wrap;
    }

    button {
      min-width: 160px;
      padding: 12px 20px;
      border-radius: 10px;
      font-weight: 600;
      border: none;
      cursor: pointer;
      transition: transform 0.15s ease, box-shadow 0.15s ease;
    }

    button:hover {
      transform: translateY(-1px);
    }

    .retry-btn {
      background: linear-gradient(135deg, #2563eb, #4f46e5);
      color: white;
      box-shadow: 0 8px 20px rgba(37, 99, 235, 0.35);
    }

    .back-btn {
      background: var(--fd-soft-bg);
      color: #0f172a;
    }

    @keyframes fadeUp {
      from {
        opacity: 0;
        transform: translateY(10px) scale(0.96);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
  `]
})
export class ServerDownComponent {
  constructor(
    private http: HttpClient,
    private router: Router,
    private location: Location
  ) {}

  // ✅ Manual Retry Only
  retryNow() {
    this.http.get(
      `${environment.apiUrl}/health`,
      { responseType: 'text' }
    ).subscribe({
      next: () => {
        this.goBack(); // ✅ Go back to the exact previous page
      },
      error: () => {}
    });
  }

  // ✅ Go Back to Previous Route (NOT HOME)
  goBack() {
    this.location.back();
  }
}
